import React from "react";

const DownArrow = () => {
  return (
    <svg style={{marginLeft:"5px"}} width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M0.646447 0.312951C0.841709 0.117688 1.15829 0.117688 1.35355 0.312951L5 3.9594L8.64645 0.312951C8.84171 0.117688 9.15829 0.117688 9.35355 0.312951C9.54882 0.508213 9.54882 0.824795 9.35355 1.02006L5.35355 5.02006C5.15829 5.21532 4.84171 5.21532 4.64645 5.02006L0.646447 1.02006C0.451184 0.824795 0.451184 0.508213 0.646447 0.312951Z" fill="#17142A"/>
</svg>
  );
};

export default DownArrow;
